import { useState } from 'react';
import { useNavigate } from 'react-router';

import type { PlatformUserFilters } from '@/entities/user';
import { Pager } from '@/shared/ui';

import { paths } from '@/app/router/paths';
import { AdminHeader } from './components/AdminHeader';
import { AdminRegion } from './components/AdminRegion';
import { PlatformUsersTable } from './components/PlatformUsersTable';
import { adminCopy } from './copy';
import { usePlatformTenants, usePlatformUsers } from './hooks';

/**
 * Platformbeheer - wie werkt waar. Eén rij per persoon over alle organisaties
 * heen; een rij opent die persoon op zijn eigen adres.
 */
export function AdminUsersPage() {
    const navigate = useNavigate();
    const [filters, setFilters] = useState<PlatformUserFilters>({ page: 1 });

    const users = usePlatformUsers(filters);
    const tenants = usePlatformTenants({});
    const total = users.data?.meta?.total ?? users.data?.items.length ?? 0;

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <AdminHeader
                eyebrow={`${adminCopy.eyebrowPlatform} · ${adminCopy.userCount(total)}`}
                title={adminCopy.metricsToUsers}
            />

            <div className="flex-1 overflow-auto bg-[var(--surface-page)] px-7 pt-[22px] pb-8">
                <AdminRegion
                    title={adminCopy.usersTitle}
                    errorTitle={adminCopy.usersError}
                    query={users}
                >
                    {users.data ? (
                        <PlatformUsersTable
                            users={users.data.items}
                            filters={filters}
                            onFiltersChange={setFilters}
                            tenants={tenants.data?.items ?? []}
                            onOpen={(user) => navigate(paths.adminUser(user.uuid))}
                            footer={
                                <Pager
                                    meta={users.data.meta}
                                    noun={adminCopy.usersNoun}
                                    busy={users.isFetching}
                                    onPage={(page) => setFilters({ ...filters, page })}
                                />
                            }
                        />
                    ) : null}
                </AdminRegion>
            </div>
        </div>
    );
}
